import {Component, EventEmitter, Input, Output} from '@angular/core';
import {fadeInOut} from '../../animations/animations';

@Component({
  selector: 'app-dialog-progress',
  templateUrl: './dialog-progress.component.html',
  animations: [fadeInOut],
  styleUrls: ['./dialog-progress.component.scss'],
})
export class DialogProgressComponent {
  @Input() show: boolean;
  @Input() labels: string[] = [];

  @Input()
  set progress(val: number) {
    this.progressInner = val;

    if (val > this.maxProgress) {
      this.maxProgress = val;
    }
  }

  get progress(): number {
    return this.progressInner;
  }

  @Input() progressTitle = 'Your Progress';

  @Output() cancel: EventEmitter<void> = new EventEmitter();

  maxProgress = 0;
  private progressInner = 0;

  constructor() {
  }

  isLabelCompleted(i: number): boolean {
    return this.maxProgress > i;
  }

}
